import { render, staticRenderFns } from "./accountDialog.vue?vue&type=template&id=2f0a0d9a&scoped=true&"
import script from "./accountDialog.vue?vue&type=script&lang=js&"
export * from "./accountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a0d9a",
  null
  
)

export default component.exports